import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Row, Table, Modal, ModalBody, ModalHeader, Badge } from 'reactstrap';
import Skeleton from "react-loading-skeleton";
import Image from '../../components/Image'
import dummyRoundedImage from "../../assets/images/dummy-rounded-image.png"
import { getCallLogs, getCallRecordings } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';
import { formatTimeFromSeconds, formatDate, formatTime, splitDestination } from '../../helper/format';
import { EmptyRow } from '../../components/EmptyState';
import { compressToEncodedURIComponent } from "lz-string";
import { useHorizontalScrollShadow } from '../../hooks/useHorizontalScrollShadow';

const ListCalls = () => {
  const { scrollRef, isScrolled } = useHorizontalScrollShadow();
  const history = useNavigate();
  const [loading, setLoading] = useState(false)
  const [callLogs, setCallLogs] = useState([])
  const [selectedLog, setSelectedLog] = useState({})
  const [viewModal, setViewModal] = useState(false);
  const [mode, setMode] = useState(false);
  const [keyword, setKeyword] = useState("");
  const keywordRef = useRef("");

  const [selectedVoice, setSelectedVoice] = useState(1);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentlyPlayingVoice, setCurrentlyPlayingVoice] = useState(null);
  const [voiceLoading, setVoiceLoading] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    fetchCallLogs();
  }, [])

  const fetchCallLogs = (keyword="") => {
    setLoading(true)
    setCallLogs([])
    getCallLogs({...(keyword && keyword.length && { search: keyword.replace(/^\+/, '') }), type: "call"}).then((data) => {
      if (data.data) {
        setCallLogs(data.data ? data.data : [])
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
    })
  }

  const searchByKeyword = (e) => {
    e.preventDefault();
    setKeyword(keywordRef.current.value);
    fetchCallLogs(keywordRef.current.value)
  }


  const handleViewModal = (mode, log) => {
    setSelectedLog(log)
    setMode(mode)
    setViewModal(true)
  }

  const handlePlayPause = async (callSid, index) => {
    // If the same recording is clicked again
    if (currentlyPlayingVoice === index) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
      return;
    }

    // If a new recording is selected
    setVoiceLoading(true);
    setIsPlaying(false);
    setSelectedVoice(null);

    getCallRecordings(`?sid=${callSid}`).then((data) => {
      if (data) {
        const audioBlob = new Blob([data.data], { type: 'audio/mpeg' });
        const audioUrl = URL.createObjectURL(audioBlob);

        setSelectedVoice(audioUrl);
        setCurrentlyPlayingVoice(index);
        setIsPlaying(true);

        // Delay to ensure audio ref picks up new URL before playing
        setTimeout(() => {
          audioRef.current?.play();
        }, 100);
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setVoiceLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setVoiceLoading(false)
    })
  };

  const handleDownload = async (callSid) => {
    setVoiceLoading(true);
    getCallRecordings(`?sid=${callSid}`).then((data) => {
      if (data) {
        const blob = new Blob([data.data], { type: 'audio/mpeg' });
        const url = window.URL.createObjectURL(blob);
    
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `recording-${callSid}.mp3`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setVoiceLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setVoiceLoading(false)
    })
  };
  return (
    <div className="content-page">
      <div className="content">

        <div className="container-fluid">

          <div className="py-3 py-3 row">
            <div className="col-12">

              <Row className="my-2 align-items-center">
                <Col md={8}>
                  <h4>Calls List</h4>
                  <p className='text-muted fs-12'>Manage and monitor your AI calls</p>
                </Col>
                <Col md={4} className='text-right'>
                  <Link id='make-call-btn' to={"/make-call"} className="font-normal py-2 px-4 rounded fs-15 text-decoration-none text-white linear-gradient-btn"><i className="ri-phone-line"></i> Make Call</Link>
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={5}>
                  {/* <form className=""> */}
                    <div className='d-flex'>
                      <div className="position-relative w-70 me-2">
                        <input type="text" className="form-control p-2 ps-4" placeholder="Search..." ref={keywordRef} />
                        <i className="ri-search-line fs-16 position-absolute text-muted top-50 translate-middle-y ms-2"></i>
                      </div>
                      <Button type='button' disabled={loading} onClick={(e) => { searchByKeyword(e) }} className="font-normal py-2 px-4 rounded fs-14 linear-gradient-btn">Search</Button>
                    </div>
                  {/* </form> */}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className={`table-responsive${isScrolled ? ' is-scrolled' : ''}`} ref={scrollRef}>
                  <Table hover className='border-rounded custom-listing-tables table-cols-calls table-sticky-first'>
                    <thead>
                      <tr>
                        <th>Agent</th>
                        <th>Date</th>
                        <th>Phone</th>
                        <th>Length</th>
                        <th>Campaign</th>
                        <th className="text-center">Status</th>
                        <th>Analysis</th>
                        <th>Converted</th>
                        <th>Summary</th>
                        <th>Transcript</th>
                        <th className="p-1 text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        loading ?
                          [...Array(30)].map((a, i) => {
                            return <tr key={i}>
                              <td className="fs-12"><div className='d-flex align-items-center'><Skeleton height={40} width={40} circle={true} className='me-2' /><Skeleton height={12} width={90} /></div></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={90} /></td>
                              <td className="fs-12"><Skeleton height={12} width={90} /></td>
                              <td className="fs-12 text-center"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12 text-center"><Skeleton height={12} width={40} /></td>
                            </tr>
                          }) :
                          callLogs.length === 0 ?
                            <EmptyRow colSpan={11} icon="ri-phone-line" title="No calls in this range" body="Try widening the date range or clearing your filters." /> :
                            callLogs.map((log, i) => {
                              const dest = splitDestination(log.to);
                              return <tr key={i}>
                                <td className="fs-12 fw-500"><div className='d-flex align-items-center'><Image src={dummyRoundedImage} alt="Event" className='rounded-circle me-2' height='28px' width='28px' objectFit='cover' /><p className='m-0'>{log.agentId ? log.agentId.name : "N/A"} <span className=' d-block text-muted fs-12 text-capitalize'>{log.agentId ? log.agentId.type : "N/A"}</span></p></div></td>
                                <td className="fs-12 fw-500 text-nowrap">
                                  {formatDate(log.createdAt)}
                                  <span className="d-block text-muted">{formatTime(log.createdAt)}</span>
                                </td>
                                <td className="fs-12 fw-500 text-nowrap" title={log.to || ''}>
                                  {dest.primary}
                                  {dest.secondary ? <span className="d-block text-muted">{dest.secondary}</span> : null}
                                </td>
                                <td className="fs-12 fw-500 text-nowrap">{formatTimeFromSeconds(log.callLength)}</td>
                                <td className="fs-12 fw-500">{(log.campaignId && log.campaignId.length) ? log.campaignId[0].name : "N/A"}</td>
                                <td className="fs-12 fw-500 text-center">{log.status === "completed" ? <Badge color='badge-success badge-soft-success fs-12 text-capitalize'>{log.status}</Badge> : <Badge color='badge-danger badge-soft-danger fs-12 text-capitalize'>{log.status}</Badge>}</td>
                                <td className="fs-12 fw-500">{log.analysis ? <p className='text-decoration-underline m-0 cursor-pointer' onClick={() => { handleViewModal('analysis', log) }}>View</p> : "N/A"}</td>
                                <td className="fs-12 fw-500">{log.conversationDetails && log.conversationDetails.analysis ? log.conversationDetails.analysis.call_successful === "failure" ? <Badge color='badge-danger badge-soft-danger fs-12'>No</Badge> : <Badge color='badge-success badge-soft-success fs-12'>Yes</Badge> : "N/A"}</td>
                                <td className="fs-12 fw-500">{log.summary ? <p className='text-decoration-underline m-0 cursor-pointer' onClick={() => { handleViewModal('summary', log) }}>View</p> : "N/A"}</td>
                                <td className="fs-12 fw-500">{log.transcript ? <p className='text-decoration-underline m-0 cursor-pointer' onClick={() => { handleViewModal('transcript', log) }}>View</p> : "N/A"}</td>
                                <td className="fs-12 p-1 fw-500 text-center">
                                  {/* Flex row with a single gap, rather than per-button margin
                                      utilities. Previously only the first button carried `me-1`,
                                      so the gap between buttons 1-2 was 4px and between 2-3 was
                                      zero — JSX strips the newline whitespace between elements,
                                      so nothing filled it. */}
                                  <div className="d-inline-flex align-items-center justify-content-center gap-2">
                                  {
                                    log.callLength && log.callLength > 0 && log.transcript ?
                                      <>
                                      <button
                                        disabled={voiceLoading}
                                        value={log.callSid}
                                        className='play-recording'
                                        title={currentlyPlayingVoice === i && isPlaying ? 'Pause recording' : 'Play recording'}
                                        onClick={() => handlePlayPause(log.callSid, i)}
                                      >
                                        <i className={`ri-${currentlyPlayingVoice === i && isPlaying ? 'pause' : 'play'}-fill`}></i>
                                      </button>
                                      <button
                                        disabled={voiceLoading}
                                        className="play-recording"
                                        title="Download recording"
                                        onClick={() => handleDownload(log.callSid)}
                                      >
                                        <i className="ri-download-2-line"></i>
                                    </button>
                                      </> : ""
                                  }
                                  <button
                                        disabled={voiceLoading || !log.to || !log.agentId?.agentId}
                                        className="play-recording"
                                        title="Call this number again"
                                        onClick={() => {
                                          const payload = {
                                              to: log.to,
                                              agent: log.agentId
                                                  ? {
                                                      _id: log.agentId._id,
                                                      agentId: log.agentId.agentId,
                                                      name: log.agentId.name,
                                                      type: log.agentId.type,
                                                      firstMessage: log.agentId.firstMessage,
                                                      purpose: log.agentId.purpose,
                                                      prompt: log.agentId.prompt
                                                  }
                                                  : null
                                          };
                                      
                                          history(`/make-call?data=${compressToEncodedURIComponent(JSON.stringify(payload))}`);
                                      }}
                                      
                                      >
                                        <i className="ri-phone-line"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            })

                      }
                    </tbody>
                  </Table>
                  </div>
                  {selectedVoice && (
                    <div className='d-none'>
                      <audio
                        controls
                        src={selectedVoice}
                        ref={audioRef}
                        onEnded={() => {
                          setIsPlaying(false);
                          setCurrentlyPlayingVoice(null);
                        }}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </div>
            <Modal isOpen={viewModal} toggle={() => { setViewModal(false) }} centered={true} size='lg'>
              <ModalHeader toggle={() => { setViewModal(false) }}>
                <small>{mode === 'summary' ? "Summary" : mode === 'transcript' ? "Transcript" : "Analysis"}</small>
              </ModalHeader>
              <ModalBody>
                {
                  mode === 'analysis' ?
                    <Row>
                      <Col md={12} className='mb-4'>
                        {
                          selectedLog.analysis && selectedLog.analysis.data_collection_results_list && selectedLog.analysis.data_collection_results_list.length ?
                            selectedLog.analysis.data_collection_results_list.map((item, idx) => (
                              <div key={idx} className='mb-3 p-2 border rounded'>
                                <p className='fw-600 mb-1'>{item.data_collection_id}</p>
                                <p className='mb-1'><strong>Result: </strong>{String(item.value)}</p>
                                <p className='mb-0 text-muted fs-13'><strong>Rationale: </strong>{item.rationale}</p>
                              </div>
                            )) :
                            <p className='text-muted m-0'>No analysis data available</p>
                        }
                      </Col>
                    </Row> :
                    <Row>
                      <Col md={12} className='mb-4'>
                        <textarea disabled={true} value={mode === 'summary' ? selectedLog.summary : selectedLog.transcript} className='fs-16 rounded p-2 custom-textarea' ></textarea>
                      </Col>
                    </Row>
                }
                <Row className="text-center mt-3">
                  <Col>
                    <button className="btn btn-outline-primary mr-2" onClick={() => { setViewModal(false) }}>Close</button>
                  </Col>
                </Row>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListCalls
